import { useState, useEffect } from 'preact/hooks';
import style from './CreditCardBox.css';
import useTranslation from '../../../localization/i18n.context';
import ChevronDownIcon from '../../shared/Icons/ChevronDownIcon';
import BulletRow from '../../shared/BulletRow/BulletRow';
import { renderIf } from '../../../utils/render.utils';
import CreditPaymentMessage from './CreditPaymentMessage';
import FormatterUtils from '../../../utils/formatter.utils';
import PaymentStatus from '../../../constants/payment.status';

export default function CreditCardBox({
  credit,
  payment,
  cardUid = '',
  cardStatus = '',
  organization = '',
  className = '',
  expanded = false,
}) {
  const [isExpanded, setIsExpanded] = useState(expanded);
  const { t, getCurrency } = useTranslation();
  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  useEffect(() => {
    setIsExpanded(payment != null);
  }, [payment]);

  return (
    <div className={`${className} ${style.card}`}>
      <div className={style['row-inner']} onClick={toggleExpand}>
        <span className={style['row-label']}>{t('Credit limit')}</span>
        <div className={style['row-right-section']}>
          <span className={style['row-value']}>
            {FormatterUtils.currency(
              credit.availableAmount,
              getCurrency(credit.currency),
            )}
          </span>
          {renderIf(
            payment,
            <ChevronDownIcon
              width={32}
              height={32}
              className={isExpanded ? style['arrow-up'] : style['arrow-down']}
            />,
          )}
        </div>
      </div>
      {renderIf(
        isExpanded && payment,
        <div className={style['expanded-content']}>
          <div className={style.items}>
            <BulletRow
              title={t('Next payment')}
              subtitle={FormatterUtils.currency(
                payment?.amount,
                getCurrency(credit.currency),
              )}
            />
            <BulletRow
              type={
                payment?.status === PaymentStatus.OVERDUE
                  ? BulletRow.Type.ERROR
                  : BulletRow.Type.INFO
              }
              title={t('Next payment due date')}
              subtitle={FormatterUtils.longDate(payment?.dueDate)}
            />
          </div>
          <CreditPaymentMessage
            status={payment?.status}
            amount={payment?.amount}
            organization={organization}
            cardUid={cardUid}
            cardStatus={cardStatus}
            availableDate={FormatterUtils.longDate(payment?.availableDate)}
          />
        </div>,
      )}
    </div>
  );
}
